// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dashboard-widget .dashboard-widget-body{margin:auto;max-width:1400px;padding:1em 1em 2em}.dashboard-widget .dashboard-widget-body .dashboard-widget-title{font-size:20px;font-weight:800}.dashboard-widget .dashboard-widget-body .dashboard-widget-subtitle{font-size:12px}.dashboard-widget.bg-darkerGray,.dashboard-widget.bg-gray{background-color:#fff}", ""]);
// Exports
module.exports = exports;
